import * as React from 'react';
import { Input, Spin } from 'antd';
import PictureModel from '../../../../../model/picture/PictureModel';
import { observer } from 'mobx-react-lite';
import Image from '../Image';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';
import AntdCustomButton from '../../../../../../../components/buttons/AntdCustomButton';

const { Search } = Input;

interface FCProps {
  scrollTab?: () => any;
}

const StockImagesTab: React.FC<FCProps> = observer(({ scrollTab }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex flex-col gap-2">
        <Search
          placeholder={t('Search')}
          className='search-images-input'
          onSearch={(query) => {
            PictureModel.searchStockImages(query);
          }}
          style={{ width: '100%' }}
        />
        <div className="flex flex-row flex-wrap justify-between gap-2">
          {PictureModel.paginatedStockImages.map((picture) => {
            return (
              <Image
                key={picture.media_id}
                type="stock"
                mediaId={picture.media_id}
                src={picture.thumbnailUrl}
              />
            );
          })}
        </div>

        {PictureModel.loadingImages && (
          <div className="flex w-full items-center justify-center h-[200px]">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
          </div>
        )}

        {PictureModel.paginatedStockImages.length <
          PictureModel.stockImages.length && (
          <div>
            <AntdCustomButton
              appearance="important" // maps to type="primary"
              onClick={() => {
                PictureModel.loadMoreStockImages();

                //setTimeout(() => {
                //  scrollTab && scrollTab();
                //}, 0);
              }}>
              {t('Load more images')}
            </AntdCustomButton>
          </div>
        )}
      </div>
    </div>
  );
});

export default StockImagesTab;
